import type { SVGProps } from 'react'
const SvgSyBlank = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path
			fillOpacity={0.24}
			d="M2 19a2 2 0 0 0 2 2h10.75a.25.25 0 0 0 .25-.25V16a2 2 0 0 1 2-2h4.75a.25.25 0 0 0 .25-.25V5a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2z"
		/>
		<path d="M16 16v4.396c0 .223.27.335.427.177l5.146-5.146a.25.25 0 0 0-.177-.427H17a1 1 0 0 0-1 1" />
	</svg>
)
export default SvgSyBlank
